var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ui--file-attachment",
      class: {
        active: _vm.modifyFlag && !_vm.itemsAdded,
        drag: _vm.modifyFlag && _vm.itemsAdded && _vm.dragging
      }
    },
    [
      _c("p", { staticClass: "message" }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("open_in_browser")]),
        _c("span", { domProps: { innerHTML: _vm._s(_vm.initMsg) } })
      ]),
      _vm._v(" "),
      _c("input", {
        staticClass: "addfile",
        style:
          (_vm.modifyFlag && _vm.itemsAdded && _vm.dragging) ||
          (_vm.modifyFlag && !_vm.itemsAdded)
            ? "z-index:25;position:absolute;top:0;bottom:0;left:0;right:0;width:100%;height:100%;"
            : "width:0%;height:0%;z-index:-1;",
        attrs: {
          type: "file",
          id: "fileAttach" + _vm.downloadType,
          name: "items[]",
          multiple: ""
        },
        on: {
          change: _vm.onChange,
          ondragover: _vm.ignoreDrag,
          dragenter: _vm.ignoreDrag,
          ondrop: _vm.onChange,
          dragend: function($event) {
            _vm.dragging = false
          },
          dragleave: function($event) {
            _vm.dragging = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ui--file-list",
          on: {
            dragenter: function($event) {
              _vm.dragging = true
            }
          }
        },
        [
          _vm.modifyFlag
            ? _c("div", { staticClass: "ui--file-button" }, [
                _c("div", { staticClass: "form-check form-check-inline" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectAll,
                        expression: "selectAll"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.selectAll)
                        ? _vm._i(_vm.selectAll, null) > -1
                        : _vm.selectAll
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      },
                      change: [
                        function($event) {
                          var $$a = _vm.selectAll,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selectAll = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selectAll = $$c
                          }
                        },
                        _vm.toggleSelectAll
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "form-check-label" })
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn ui--btn-icon-sm up",
                    attrs: { type: "button" },
                    on: { click: _vm.moveUp }
                  },
                  [
                    _c("span", { staticClass: "ui--blind" }, [
                      _vm._v(_vm._s(_vm.$t("sdl.common.label.moveup")))
                    ]),
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("arrow_drop_up")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn ui--btn-icon-sm down",
                    attrs: { type: "button" },
                    on: { click: _vm.moveDown }
                  },
                  [
                    _c("span", { staticClass: "ui--blind" }, [
                      _vm._v(_vm._s(_vm.$t("sdl.common.label.movedown")))
                    ]),
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("arrow_drop_down")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn ui--btn-icon-sm delete",
                    attrs: { type: "button" },
                    on: { click: _vm.selectRemoveItem }
                  },
                  [
                    _c("span", { staticClass: "ui--blind" }, [
                      _vm._v(_vm._s(_vm.$t("sdl.common.label.delete")))
                    ]),
                    _c("i", { staticClass: "material-icons material-xs" }, [
                      _vm._v("clear")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "ml-2 mr-2 ui--slide" }, [
                  _vm._v("|")
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("sdl.common.label.total"))),
                  _c("strong", { staticClass: "ml-1 mr-2" }, [
                    _vm._v(_vm._s(_vm.itemsAdded))
                  ]),
                  _vm._v(
                    _vm._s(_vm.itemsTotalSize) +
                      " / " +
                      _vm._s(_vm.getItemsMaxTotalSize)
                  )
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "btn btn-outline-secondary ml-3 ui--btn-xs",
                    staticStyle: { "margin-bottom": "0px" },
                    attrs: { for: "fileAttach" + _vm.downloadType }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("sdl.common.label.fileAddition")) +
                        "\n      "
                    )
                  ]
                )
              ])
            : _c("div", { staticClass: "ui--file-button" }, [
                _c("div", { staticClass: "form-check form-check-inline" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectAll,
                        expression: "selectAll"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.selectAll)
                        ? _vm._i(_vm.selectAll, null) > -1
                        : _vm.selectAll
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      },
                      change: [
                        function($event) {
                          var $$a = _vm.selectAll,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selectAll = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selectAll = $$c
                          }
                        },
                        _vm.toggleSelectAll
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "form-check-label" })
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("sdl.common.label.total"))),
                  _c("strong", { staticClass: "ml-1 mr-2" }, [
                    _vm._v(_vm._s(_vm.itemsAdded))
                  ]),
                  _vm._v("(" + _vm._s(_vm.itemsTotalSize) + ")")
                ]),
                _vm._v(" "),
                _vm.downloadType === "VOC_DATA_REQ_PROCESS_wait"
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary ml-3 ui--btn-xs",
                        attrs: { type: "button" },
                        on: { click: _vm.checkedDownloadNonZip }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("sdl.common.label.alldownload")) +
                            " \n      "
                        )
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary ml-3 ui--btn-xs",
                        attrs: { type: "button" },
                        on: { click: _vm.checkedDownload }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("sdl.common.label.alldownload")) +
                            " \n      "
                        )
                      ]
                    )
              ]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.itemsNames, function(item) {
              return _c("li", { key: item.fileName }, [
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.selected,
                        expression: "item.selected"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(item.selected)
                        ? _vm._i(item.selected, null) > -1
                        : item.selected
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = item.selected,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(item, "selected", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  item,
                                  "selected",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(item, "selected", $$c)
                          }
                        },
                        function($event) {
                          return _vm.selectRow(item)
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      style: !_vm.modifyFlag ? "cursor:pointer;" : "",
                      on: {
                        click: function($event) {
                          return _vm.download(item)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.fileName) +
                          "\n            "
                      ),
                      _c("small", [
                        _c("small", [
                          _vm._v(
                            "(" + _vm._s(_vm.bytesToSize(item.fileSize)) + ")"
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.modifyFlag,
                        expression: "modifyFlag"
                      }
                    ],
                    staticClass: "btn ui--btn-icon-sm delete",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.removeItem(item)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "ui--blind" }, [
                      _vm._v(_vm._s(_vm.$t("sdl.common.label.delete")))
                    ]),
                    _c("i", { staticClass: "material-icons material-xs" }, [
                      _vm._v("clear")
                    ])
                  ]
                )
              ])
            }),
            0
          ),
          _vm._v(" "),
          _vm.isLoaderVisible
            ? _c("div", { staticClass: "loader" }, [
                _c("div", { staticClass: "loaderImg" })
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2759ef99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2759ef99","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/fileuploader/MultipleFileUploader.vue
// module id = null
// module chunks = 